<button>Ver <span class="plus">+</span></button>
